(function () {
  var SUBSCRIBE_URL = 'https://antimerch-marketing.antimerch-withdrawal-worker.workers.dev/subscribe';

  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('artist-signup-form');
    if (!form) return;

    var messageEl = form.querySelector('.as-message');
    var submitBtn = form.querySelector('.as-submit');

    function setMessage(text, kind) {
      messageEl.textContent = text;
      messageEl.classList.remove('as-message--success', 'as-message--error');
      if (kind) messageEl.classList.add('as-message--' + kind);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      setMessage('', null);

      var email = form.email.value.trim();
      var consent = form.consent.checked;
      var artists = Array.from(form.querySelectorAll('input[name="artists"]:checked')).map(function (el) {
        return el.value;
      });

      if (!consent) {
        setMessage('Please confirm you want to receive updates to sign up.', 'error');
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Signing Up…';

      fetch(SUBSCRIBE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, artists: artists, consent: consent }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok && data.ok, data: data };
          });
        })
        .then(function (result) {
          if (result.ok) {
            setMessage('Almost done — check your inbox to confirm your email.', 'success');
            form.reset();
          } else {
            setMessage((result.data && result.data.error) || 'Something went wrong — please try again.', 'error');
          }
        })
        .catch(function () {
          setMessage('Something went wrong — please try again.', 'error');
        })
        .finally(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Sign Up';
        });
    });
  });
})();
